/** Team color helpers. ESPN gives hex without the hash and some teams are white or near-white. */
export function teamColor(hex: string | null | undefined, fallback = '#1781EB'): string {
  if (!hex) return fallback;
  const h = hex.replace('#', '');
  // Six characters is not the same as six hex digits. Length alone let "zzzzzz"
  // through, parseInt returned NaN, the luminance test on NaN is false, and the
  // function handed back "#zzzzzz": an invalid colour that renders as nothing at all.
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return fallback;
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.82 ? fallback : `#${h}`;
}

/** Two team colors as a left-to-right background for a header. */
export function duotone(away: string | null | undefined, home: string | null | undefined): string {
  const a = teamColor(away), h = teamColor(home);
  return `linear-gradient(100deg, ${a} 0%, ${a} 38%, ${h} 62%, ${h} 100%)`;
}
